export const LinkIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4184_73126)">
      <path d="M6.99999 2.16704L5.55011 3.61692C5.2843 3.88273 5.2843 4.31769 5.55011 4.5835C5.81592 4.84931 6.25089 4.84931 6.5167 4.5835L7.96657 3.13362C8.764 2.33619 10.0689 2.33619 10.8663 3.13362C11.6638 3.93106 11.6638 5.23594 10.8663 6.03337L9.41645 7.48325C9.15064 7.74906 9.15064 8.18402 9.41645 8.44983C9.68226 8.71565 10.1172 8.71565 10.383 8.44983L11.8329 6.99996C13.1668 5.66607 13.1668 3.50093 11.8329 2.16704C10.499 0.833155 8.33388 0.833155 6.99999 2.16704ZM5.06682 8.93313C5.33263 9.19894 5.76759 9.19894 6.03341 8.93313L8.93316 6.03337C9.19897 5.76756 9.19897 5.3326 8.93316 5.06679C8.66735 4.80098 8.23238 4.80098 7.96657 5.06679L5.06682 7.96654C4.80101 8.23235 4.80101 8.66732 5.06682 8.93313ZM7.48328 9.41642L6.03341 10.8663C5.23597 11.6637 3.93109 11.6637 3.13365 10.8663C2.33622 10.0689 2.33622 8.76397 3.13365 7.96654L4.58353 6.51667C4.84934 6.25086 4.84934 5.81589 4.58353 5.55008C4.31772 5.28427 3.88276 5.28427 3.61695 5.55008L2.16707 6.99996C0.833185 8.33384 0.833185 10.499 2.16707 11.8329C3.50096 13.1668 5.6661 13.1668 6.99999 11.8329L8.44987 10.383C8.71568 10.1172 8.71568 9.68223 8.44987 9.41642C8.18405 9.15061 7.74909 9.15061 7.48328 9.41642Z" />
    </g>
    <defs>
      <clipPath id="clip0_4184_73126">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
